import { useState } from 'react';
import axios from 'axios';
import { apiURL, fileApiURL } from './ApiConfig';

export function usePost() {
    const [ response, setResponse ] = useState(null);
    const [ loading,  setLoading  ] = useState(false);
    const [ error,    setError    ] = useState(null);
    axios.defaults.baseURL = apiURL;

    const post = async (data) => {
        setLoading(true);
        try {
            const resp = await axios.post(apiURL, data);
            setResponse(resp.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }
    return { response, loading, error, post };
}
export function usePostFile() {
  const [response, setResponse] = useState(null);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState(null);

  const postFile = async (formData) => {
    setLoading(true);
    setError(null);

    try {
      const resp = await axios.post(
        fileApiURL,
        formData,
        {
          // Content-Type は指定しない
          // multipart boundary は axios が自動付与
        }
      );
      setResponse(resp.data);
      return resp.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { response, loading, error, postFile };
}